import { API_URL } from "../../config";

// Extract base URL without /api suffix for admin endpoints
const base = API_URL.replace(/\/api\/?$/, "");

export const adminAPI = {
  async getStats() {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/admin/stats`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.json();
  },
  async listUsers(params = {}) {
    const token = localStorage.getItem("token");
    const qs = new URLSearchParams(params).toString();
    const res = await fetch(`${base}/api/admin/users${qs ? `?${qs}` : ""}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.json();
  },
  async updateUser(id, body) {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/admin/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return res.json();
  },
  async deleteUser(id) {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/admin/users/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.json();
  },
  async createEnterprise(body) {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/admin/enterprises`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return res.json();
  },
  async inviteManagers(enterpriseId, emails) {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${base}/api/admin/enterprises/${enterpriseId}/invite-managers`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ emails }),
      }
    );
    return res.json();
  },
  async listEnterprises(params = {}) {
    const token = localStorage.getItem("token");
    const qs = new URLSearchParams(params).toString();
    const res = await fetch(
      `${base}/api/admin/enterprises${qs ? `?${qs}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return res.json();
  },
  async getPlans() {
    const res = await fetch(`${base}/api/plans`);
    return res.json();
  },
  async updatePlan(key, body) {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/plans/${key}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    return res.json();
  },
  async getContactSubmissions() {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/contact`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.json();
  },
  async toggleContactRead(id) {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/contact/${id}/read`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.json();
  },
  async deleteContactSubmission(id) {
    const token = localStorage.getItem("token");
    const res = await fetch(`${base}/api/contact/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.json();
  },
};

export default adminAPI;
